module.exports = __webpack_public_path__ + "img/laughing.d2e1cb79.png";